import styled from "styled-components";

import { ConsolePageButton } from "pages/[tenant]/console/components/molecules/ConsolePageForm/atoms/ConsolePageButton";

export const HelpActionButton = styled(ConsolePageButton)`
  background: #f2f2f2;
  color: #050505;
`;
